import React, { useState, useRef } from 'react';
import emailjs from '@emailjs/browser';
export const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<{
    success?: boolean;
    message?: string;
  }>({});
  const formRef = useRef<HTMLFormElement>(null);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus({});
    // Initialize EmailJS with your public key
    emailjs.init('eRfwksZb_EO9Bv47N'); // Replace with your actual EmailJS public key
    // Prepare template parameters
    const templateParams = {
      to_email: 'info@i75av.com',
      from_name: formData.name,
      from_email: formData.email,
      phone: formData.phone,
      service: formData.service,
      message: formData.message
    };
    // Send the email using EmailJS
    emailjs.send('service_01hvnqb',
    // Replace with your EmailJS service ID
    'template_foda76t',
    // Replace with your EmailJS template ID
    templateParams).then(response => {
      console.log('Email sent successfully:', response);
      setSubmitStatus({
        success: true,
        message: 'Thank you! Your message has been sent successfully. We will contact you shortly.'
      });
      // Reset form
      setFormData({
        name: '',
        email: '',
        phone: '',
        service: '',
        message: ''
      });
    }).catch(error => {
      console.error('Email sending failed:', error);
      setSubmitStatus({
        success: false,
        message: 'Sorry, there was a problem sending your message. Please try again or call us directly at (239) 203-8333.'
      });
    }).finally(() => {
      setIsSubmitting(false);
    });
  };
  return <div className="bg-white rounded-xl shadow-xl p-6 md:p-8" data-id="element-75" data-mp="35wdx8c7un3x1">
      <h2 className="text-2xl font-bold text-gray-800 mb-2" data-id="element-76" data-mp="30z5heia6bbyy">
        Free Consultation
      </h2>
      <p className="text-gray-600 mb-6" data-id="element-77" data-mp="2d9ji7utswwqy">Let's Talk About Your Project</p>
      {submitStatus.message && <div className={`p-4 mb-6 rounded-lg ${submitStatus.success ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`} data-id="element-78" data-mp="2987nxbzzfncf">
          {submitStatus.message}
        </div>}
      <form ref={formRef} onSubmit={handleSubmit} data-id="element-79" data-mp="2i6t6h75gf2d7">
        <div className="mb-4" data-id="element-80" data-mp="1uhqotzatl9ip">
          <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-81" data-mp="1ugyt8oh83bsf">
            Name
          </label>
          <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all" required data-id="element-82" data-mp="50wki8ik2bpp" />
        </div>
        <div className="mb-4" data-id="element-83" data-mp="102w7e17auwa">
          <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-84" data-mp="x6y9ppcs67u">
            Email
          </label>
          <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all" required data-id="element-85" data-mp="sp5zaqhcpz7c" />
        </div>
        <div className="mb-4" data-id="element-86" data-mp="34g05lkrjfytk">
          <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-87" data-mp="34g9vz9ghw7zs">
            Phone
          </label>
          <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all" required data-id="element-88" data-mp="3jrhmslsu89jn" />
        </div>
        <div className="mb-4" data-id="element-89" data-mp="6hts1j1o7baw">
          <label htmlFor="service" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-90" data-mp="6h0sp351jo2s">
            Service Interested In
          </label>
          <select id="service" name="service" value={formData.service} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all" required data-id="element-91" data-mp="3tm9oa0pjjgjp">
            <option value="" data-id="element-92" data-mp="2dbnu87ykii8n">Select a service</option>
            <option value="home-theater" data-id="element-93" data-mp="236p9xuo9vglu">Home Theater Installations</option>
            <option value="commercial-audio" data-id="element-94" data-mp="284h9nav5s70l">Commercial Audio Systems</option>
            <option value="camera-systems" data-id="element-95" data-mp="282efcemz3rq2">Camera Systems & Door Access</option>
            <option value="wifi-networks" data-id="element-96" data-mp="2d2ir5rcxry9y">WiFi & Data Networks</option>
            <option value="programming" data-id="element-97" data-mp="2hvbzsqbizqrb">URC & Sonos Programming</option>
            <option value="other" data-id="element-98" data-mp="2lwnhm9o5r7oy">Other</option>
          </select>
        </div>
        <div className="mb-6" data-id="element-99" data-mp="2qv8fw3junhar">
          <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-100" data-mp="2qufivuap065t">
            Message
          </label>
          <textarea id="message" name="message" value={formData.message} onChange={handleChange} rows={4} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all" required data-id="element-101" data-mp="30tegmhtx6he1"></textarea>
        </div>
        <button type="submit" disabled={isSubmitting} className={`w-full ${isSubmitting ? 'bg-blue-400' : 'bg-blue-600 hover:bg-blue-700'} text-white font-bold py-3 px-6 rounded-lg transition-colors duration-300 shadow-md hover:shadow-lg flex justify-center items-center`} data-id="element-102" data-mp="yexu7ttlq7wq">
          {isSubmitting ? 'Sending...' : 'Get My Free Quote'}
        </button>
      </form>
    </div>;
};